import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PieChartComponent } from '../../../../components/chart/pie-chart/pie-chart.component';

@Component({
  selector: 'app-card-defect',
  standalone: true,
  imports: [CommonModule, PieChartComponent],
  templateUrl: './card-defect.component.html',
  styleUrl: './card-defect.component.scss'
})
export class CardDefectComponent {

  @Input() 
  data: any;

  @Input() 
  metricDisplayName: string = '';

  @Input() 
  meta: any;

  getChartData() {
    return {
      'Open Defects': this.data?.open_defects || 0,
      'Closed Defects': this.data?.closed_defects || 0
    };
  }

  getChartMeta() {
    return {
      isLegendVisible: false
    };
  }

  getPercentage(type: 'open' | 'closed'): number {
    const total = this.data?.total_defects || 0;
    if (total === 0) return 0;
    
    const value = type === 'open' ? (this.data?.open_defects || 0) : (this.data?.closed_defects || 0);
    return Math.round((value / total) * 100);
  }

}
